/** @flow */
import React from "react";
import classNames from "classnames";

type SectionItemsProps = $Exact<{
  className?: string,
  flex?: boolean,
  cols: number,
  children: React$Node,
}>;

const SectionItems = (props: SectionItemsProps) => (
  <div
    className={classNames(
      "section-items",
      {
        "flex-columns": props.flex,
        "native-columns": !props.flex,
      },
      `columns-${props.cols}`,
      props.className,
    )}
  >
    {props.children}
  </div>
);

export default SectionItems;
